import { FormHelperText } from "@material-ui/core";
import Call from "@material-ui/icons/Call";
import * as React from "react";
import { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import "../Styles/SurveyForm.css";

export const SurveyFormCredir = ({
  questions,
  handlerChange,
  submitAnswers,
  noThanks,
  campaign,
  callToAction,
  politicView
}) => {
  const [errors, setErrors] = useState({});
  const [codeArea, setCodeArea] = useState("52");
  const renderQuestion = (question) => {
    if (question) {
      switch (question.question_type) {
        case "Small Answer":
          return (
            <div className="form-group">
              <label htmlFor="">{question.question}*</label>
              <input
                type="text"
                className="form-control form-control-sm"
                value={question.answer.answer}
                id={question.id}
                required
                onChange={(e) => handlerAnswer(e.target, question)}
              />
              <FormHelperText
                id="component-error-text"
                style={{ marginBottom: "3px", color: "red" }}
              >
                {errors[question.id] && errors[question.id]}
              </FormHelperText>
            </div>
          );

        case "Multiple selection":
          return (
            <div className="form-group">
              <label>{question.question}*</label>
              <select
                className="form-control form-control-sm"
                id={question.id}
                value={question.answer.answer}
                onChange={(e) => handlerAnswer(e.target, question)}
              >
                {question.posible_answer.length > 0 &&
                  question.posible_answer.map((pa, i) => (
                    <option key={i} value={pa}>
                      {pa}
                    </option>
                  ))}
              </select>
              <FormHelperText
                id="component-error-text"
                style={{ marginBottom: "3px", color: "red" }}
              >
                {errors[question.id] && errors[question.id]}
              </FormHelperText>
            </div>
          );

        case "Paragraph":
          return (
            <div className="form-group">
              <label>{question.question}*</label>
              <textarea
                id={question.id}
                rows={4}
                required
                className="form-control form-control-sm"
                onChange={(e) => handlerAnswer(e.target, question)}
              />
              <FormHelperText
                id="component-error-text"
                style={{ marginBottom: "3px", color: "red" }}
              >
                {errors[question.id] && errors[question.id]}
              </FormHelperText>
            </div>
          );
        case "Number":
          return (
            <div className="form-group">
              <label htmlFor="">{question.question}*</label>
              <input
                id={question.id}
                type="number"
                required
                className="form-control form-control-sm"
                value={question.answer.answer}
                onChange={(e) => handlerAnswer(e.target, question)}
              />
              <FormHelperText
                id="component-error-text"
                style={{ marginBottom: "3px", color: "red" }}
              >
                {errors[question.id] && errors[question.id]}
              </FormHelperText>
            </div>
          );
        case "Telephone":
          return (
            <div className="form-group">
              <label htmlFor="">{question.question}*</label>
              <div className="row">
                <div className="col-auto">
                  <select
                    className="form-control form-control-sm"
                    value={codeArea}
                    onChange={(e) => setCodeArea(e.target.value)}
                  >
                    <option value={"52"}>52</option>
                    <option value={"1"}>1</option>
                  </select>
                </div>
                <div className="col">
                  <input
                    id={question.id}
                    type="tel"
                    required
                    maxLength={10}
                    className="form-control form-control-sm"
                    value={question.answer.answer}
                    onChange={(e) => handlerAnswer(e.target, question)}
                  />
                </div>
              </div>

              <FormHelperText
                id="component-error-text"
                style={{ marginBottom: "3px", color: "red" }}
              >
                {errors[question.id] && errors[question.id]}
              </FormHelperText>
            </div>
          );
        case "Date":
          return (
            <div className="form-group">
              <label htmlFor="">{question.question}*</label>
              <input
                id={question.id}
                type="date"
                required
                className="form-control form-control-sm"
                value={question.answer.answer}
                onChange={(e) => handlerAnswer(e.target, question)}
              />
              <FormHelperText
                id="component-error-text"
                style={{ marginBottom: "3px", color: "red" }}
              >
                {errors[question.id] && errors[question.id]}
              </FormHelperText>
            </div>
          );
      }
    }
  };

  const handlerAnswer = (target, question) => {
    let { value, id, type, required } = target;
    if (type === "tel") {
      value = codeArea + value;
    }
    if (required && !value) {
      setErrors({
        ...errors,
        [id]: "Completa este campo",
      });
    } else {
      setErrors({
        ...errors,
        [id]: "",
      });
    }
    handlerChange(question, value);
  };

  const actionSumbit = (e) => {
    e.preventDefault();
    let values = Object.keys(errors);
    if (values.length === 0 || values.length < questions.length) {
      let questionErrors = {};
      for (const q of questions) {
        let key = values.find((id) => q.id === Number(id));
        if (key) {
          questionErrors = { ...questionErrors, [key]: errors[key] };
        } else {
          questionErrors = { ...questionErrors, [q.id]: "Completa este campo" };
        }

        if (q.answer.answer) {
          questionErrors = { ...questionErrors, [q.id]: null };
        }
      }
      setErrors({
        ...questionErrors,
      });
      return;
    }
    if (Object.values(errors).filter((v) => v).length === 0) {
      submitAnswers();
    }
  };

  return (
    <div
      className="SurveyFormCard card"
      style={{ backgroundColor: "#000", color: "#fff" }}
    >
      <div className="card-body">
        <form onSubmit={(e) => actionSumbit(e)} noValidate>
          <div className="form-group">
            {questions.length > 0 &&
              questions.map((question) => (
                <Fragment key={question.id}>
                  {renderQuestion(question)}
                </Fragment>
              ))}
          </div>
          <div className="row justify-content-center">
            <div className="col-12">
              <button
                className="btn btn-sm btn-success"
                style={{
                  width: "100%",
                  color: "#eee",
                }}
                type="submit"
              >
                Solicitar
              </button>
            </div>
            {campaign.call_action && (
              <div className="col-12 pt-2">
                <button
                  className="btn btn-sm btn-primary"
                  style={{
                    width: "100%",
                    color: "#eee",
                  }}
                  onClick={() => callToAction()}
                >
                  <Call/>
                  {campaign.call_label ? campaign.call_label : "Llamar"}
                </button>
              </div>
            )}

            <div className="col-12 pt-1">
              <Link to="/politicas" onClick={() => politicView()}>
                Al hacer click aceptas haber leído nuestra{" "}
                <u>politica de privacidad</u>
              </Link>
            </div>
            <div className="col-12 pt-1">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="exampleRadios"
                  id="exampleRadios1"
                  value="option1"
                  onChange={(e) => noThanks()}
                />
                <label className="form-check-label">
                  No Gracias, no lo requiero
                </label>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
